module.exports = __webpack_public_path__ + "poppins-medium_0-webfont.95d6639d90c3d89cd7fb.ttf";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/fonts/poppins-medium_0-webfont.ttf
// module id = ../../../../../src/assets/fonts/poppins-medium_0-webfont.ttf
// module chunks = 2